module.exports = __webpack_public_path__ + "img/NuevoLogoIbero.00b7c0d2.png";